import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { MediaProvider } from "./lib/media";
import { TreatmentsProvider } from "./lib/treatments";
import { I18nProvider } from "./lib/i18n";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Treatments from "./pages/Treatments";
import Consultations from "./pages/Consultations";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
// SEO landing pages
import DhaturogTreatment from "./pages/seo/DhaturogTreatment";
import MasturbationTreatment from "./pages/seo/MasturbationTreatment";
import NightfallTreatment from "./pages/seo/NightfallTreatment";
import LowLibidoTreatment from "./pages/seo/LowLibidoTreatment";
import LowSpermCountTreatment from "./pages/seo/LowSpermCountTreatment";
import GuptRogDoctor from "./pages/seo/GuptRogDoctor";
import SexClinicAllahabad from "./pages/seo/SexClinicAllahabad";
import { initGTM, attachCtaListeners, trackPageView } from "./lib/analytics";

// Fires a GTM page_view on every client-side route change.
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    // Wait a tick for <title> updates from useSeo to land.
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
}

function AnalyticsBoot() {
  useEffect(() => {
    initGTM();
    attachCtaListeners();
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <AnalyticsBoot />
      <AuthProvider>
        <MediaProvider>
          <TreatmentsProvider>
          <I18nProvider>
          <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/treatments" element={<Treatments />} />
              <Route path="/mens-ayurvedic-treatment" element={<Treatments />} />
              <Route path="/consultations" element={<Consultations />} />
              <Route path="/book-appointment" element={<Consultations />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              {/* SEO landing pages */}
              <Route path="/dhatu-rog-treatment-prayagraj" element={<DhaturogTreatment />} />
              <Route path="/masturbation-treatment-prayagraj" element={<MasturbationTreatment />} />
              <Route path="/nightfall-treatment-prayagraj" element={<NightfallTreatment />} />
              <Route path="/low-libido-treatment-prayagraj" element={<LowLibidoTreatment />} />
              <Route path="/low-sperm-count-treatment-prayagraj" element={<LowSpermCountTreatment />} />
              <Route path="/gupt-rog-doctor-prayagraj" element={<GuptRogDoctor />} />
              <Route path="/sex-clinic-allahabad" element={<SexClinicAllahabad />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
          </BrowserRouter>
          </I18nProvider>
          </TreatmentsProvider>
        </MediaProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
